<template>
  <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="11.424" height="11.424" viewBox="0 0 11.424 11.424">
    <g data-name="Symbol 5" transform="translate(96 -7835)">
      <rect data-name="Rectangle 176" width="11.424" height="11.424" transform="translate(-96 7835)" fill="none"/>
      <path data-name="Path 99" d="M11.352,10.353,9,8a4.889,4.889,0,0,0,1-3A4.967,4.967,0,0,0,5,0,4.967,4.967,0,0,0,0,5a4.967,4.967,0,0,0,5,5A4.889,4.889,0,0,0,8,9l2.356,2.356ZM1.428,5A3.535,3.535,0,0,1,5,1.428,3.535,3.535,0,0,1,8.568,5,3.535,3.535,0,0,1,5,8.568,3.535,3.535,0,0,1,1.428,5Z" transform="translate(-96 7835)" fill="#fff"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'SearchIcon'
  }
</script>

<style>

</style>